"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addWebBlConsigneeCertification = addWebBlConsigneeCertification;
exports.cancelSubmitWebBlConsigneeCertification = cancelSubmitWebBlConsigneeCertification;
exports.deletehWebBlConsigneeCertification = deletehWebBlConsigneeCertification;
exports.loadByBlNo = loadByBlNo;
exports.saveWebBlConsigneeCertification = saveWebBlConsigneeCertification;
exports.searchWebBlConsigneeCertification = searchWebBlConsigneeCertification;
exports.setDownLoadLetter = setDownLoadLetter;
exports.setDownloadFile = setDownloadFile;
exports.submithWebBlConsigneeCertification = submithWebBlConsigneeCertification;
var _request = _interopRequireDefault(require("@/utils/request"));
function addWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/add',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    params: data
  });
}
function searchWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/search',
    // url: '/webBlConsigneeCertification/search',
    method: 'get',
    params: data
  });
}
function deletehWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/deleteBatch',
    // url: '/webBlConsigneeCertification/deleteBatch',
    method: 'post',
    data: data
  });
}
function saveWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/edit',
    // url: '/webBlConsigneeCertification/edit',
    method: 'post',
    data: data
  });
}
function submithWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/submit',
    // url: '/webBlConsigneeCertification/submit',
    method: 'post',
    data: data
  });
}
function cancelSubmitWebBlConsigneeCertification(data) {
  return (0, _request.default)({
    url: '/ebusiness/webBlConsigneeCertification/cancelSubmit',
    // url: '/webBlConsigneeCertification/cancelSubmit',
    method: 'post',
    data: data
  });
}
function setDownLoadLetter(letterOfCommitment) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/ebusiness/webBlConsigneeCertification/downLoadLetter/".concat(letterOfCommitment),
    method: 'get'
  });
}

//根据提单号，查看明细
function loadByBlNo(blNo) {
  return (0, _request.default)({
    url: "/ebusiness/credit/loadByBlNo/".concat(blNo),
    method: 'get'
  });
}
function setDownloadFile(fileId) {
  return (0, _request.default)({
    responseType: 'blob',
    url: "/sitceb-system-service/file/downloadFile/".concat(fileId),
    method: 'get'
  });
}